import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useEffect, useState } from 'react';
import i18n from 'i18next';
import { Globe } from 'lucide-react';
import { useLocation, useNavigate, useSearch } from '@tanstack/react-router';

type TLanguagePickerProps = {
  defaultValue?: TLanguage;
};

export type TLanguage = 'en' | 'fr' | 'es';

export function LanguagePicker({ defaultValue = 'en' }: TLanguagePickerProps) {
  const urlSearch = useSearch({ strict: false });
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedLanguage, setSelectedLanguage] = useState<TLanguage>(() => {
    const languageFromQuery = urlSearch.language;
    return (languageFromQuery || defaultValue) as TLanguage;
  });

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);

    navigate({
      to: location.pathname,
      search: (prev) => ({ ...prev, language: selectedLanguage }),
    });
  }, [location.pathname, navigate, selectedLanguage]);

  const handleSelectChange = (value: TLanguage) => {
    setSelectedLanguage(value);
  };

  const valueToDisplay = {
    en: 'English',
    fr: 'français',
    es: 'español',
  };

  return (
    <div className='flex items-center gap-2'>
      <Select value={selectedLanguage} onValueChange={handleSelectChange}>
        <SelectTrigger className='w-36 bg-transparent'>
          <SelectValue placeholder='Select Language'>
            <div className='flex items-center gap-3'>
              <Globe className='text-foreground' />{' '}
              {selectedLanguage ? valueToDisplay[selectedLanguage] : ''}
            </div>
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value='en'>English - EN</SelectItem>
          <SelectItem value='fr'>français - FR</SelectItem>
          <SelectItem value='es'>español - ES</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
